// src/utils/constants.js
export const API = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export const PARTICLE_COLORS = ["#9b7fd4", "#c9a84c", "#7b5ea7", "#e8c97a", "#ffffff"];

export const BANNER_ICONS = [
  "Sword","Trees","Megaphone","Pickaxe","Castle",
  "Newspaper","Sparkles","Trophy","Crown","Package","Mountain","Coins",
];

export function fmtDate(dateStr) {
  const d = new Date(dateStr);
  return {
    day: String(d.getDate()).padStart(2, "0"),
    mon: d.toLocaleString("en-GB", { month: "short" }).toUpperCase(),
  };
}
